import { render, staticRenderFns } from "./withdrawPwdPopup.vue?vue&type=template&id=1b19b55a&scoped=true"
import script from "./withdrawPwdPopup.vue?vue&type=script&lang=js"
export * from "./withdrawPwdPopup.vue?vue&type=script&lang=js"
import style0 from "./withdrawPwdPopup.vue?vue&type=style&index=0&id=1b19b55a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b19b55a",
  null
  
)

export default component.exports